module.exports = __webpack_public_path__ + "img/electrico.cf972650.jpeg";